import type { IContextDocumentIngestionStatus, IContextDocumentType } from '@/lib/constants/contextDocuments'

const DOCUMENT_TYPES: Record<IContextDocumentType, string> = {
  policy: 'Política',
  procedure: 'Procedimiento',
  register: 'Registro',
  document: 'Documento',
}

const AGENT_STATUS: Record<IContextDocumentIngestionStatus, string> = {
  pending: 'Procesando',
  indexed: 'Disponible para el agente',
  failed: 'No se pudo procesar',
}

export const CONTEXT_DOCUMENTS = {
  TITLE: 'Más contexto',
  UPLOAD_BUTTON: 'Subir archivo',
  SEARCH_PLACEHOLDER: 'Buscar por nombre',
  EMPTY: 'Aún no hay archivos',
  NO_RESULTS: 'Ningún archivo coincide con los filtros',
  STALE: 'Más de 12 meses',
  INGESTION_TIMEOUT: 'El procesamiento tardó demasiado. Reemplaza el archivo para reintentarlo',
  INGESTION_ERROR: 'No se pudo enviar el archivo al agente. Inténtalo de nuevo o sustituye el archivo.',
  DOCUMENT_TYPES,
  AGENT_STATUS,
  COLUMNS: {
    NAME: 'Nombre',
    TYPE: 'Tipo',
    VISIBILITY: 'Visibilidad',
    OWNER: 'Responsable',
    LAST_REVIEW: 'Última revisión',
    UPLOADED: 'Subido',
    AGENT_STATUS: 'Estado en el agente',
    ACTIONS: 'Acciones',
  },
  ACTIONS: {
    DOWNLOAD: 'Descargar',
    EDIT: 'Editar detalles',
    MARK_REVIEWED: 'Marcar como revisado',
    REPLACE: 'Reemplazar archivo',
    DELETE: 'Eliminar',
    MORE: 'Más acciones',
  },
  DIALOG: {
    UPLOAD_TITLE: 'Subir archivo',
    EDIT_TITLE: 'Editar detalles',
    UPLOAD: 'Subir',
    UPLOADING: 'Subiendo...',
    SAVE: 'Guardar',
    SAVING: 'Guardando...',
    NAME: 'Nombre',
    DESCRIPTION: 'Descripción',
    DESCRIPTION_PLACEHOLDER: '¿Qué demuestra este archivo?',
    TYPE: 'Tipo',
    VISIBILITY: 'Visibilidad',
    OWNER: 'Responsable',
    LAST_REVIEW: 'Última revisión',
    SELECT_TYPE: 'Selecciona un tipo',
    SELECT_VISIBILITY: 'Selecciona una visibilidad',
    SELECT_OWNER: 'Selecciona un responsable',
    FILE_TYPE_HINT: 'PDF, Word, Excel, CSV, TXT, Markdown o HTML',
  },
  REPLACE_DIALOG: {
    TITLE: 'Reemplazar archivo',
    DESCRIPTION_PREFIX: '¿Reemplazar el archivo de',
    DESCRIPTION_SUFFIX: 'La versión anterior se perderá y el agente leerá la nueva.',
    CONFIRM: 'Reemplazar',
  },
  DELETE_DIALOG: {
    TITLE: 'Eliminar archivo',
    DESCRIPTION_PREFIX: '¿Eliminar',
    DESCRIPTION_SUFFIX: 'El agente dejará de usarlo.',
  },
  MESSAGES: {
    UPLOADED: 'Archivo subido',
    UPDATED: 'Detalles guardados',
    REVIEWED: 'Marcado como revisado',
    REPLACED: 'Archivo reemplazado',
    DELETED: 'Archivo eliminado',
  },
  ERRORS: {
    NOT_FOUND: 'Este archivo ya no existe. Recarga la página.',
    FILE_MISSING: 'El contenido de este archivo ya no está disponible. Reemplaza el archivo para recuperarlo.',
    INVALID_OWNER: 'El responsable seleccionado no puede serlo de estos archivos. Elige otro.',
    INVALID_FIELDS: 'Faltan datos o no son válidos. Revísalos e inténtalo de nuevo.',
    INVALID_ID: 'El enlace al archivo no es válido.',
    FORBIDDEN: 'No tienes permiso para hacer esto.',
    GENERIC: 'Algo salió mal. Inténtalo de nuevo.',
  },
}
